import { forwardRef, useLayoutEffect, useMemo, useRef, useState } from 'react';

export default function Reviews() {
  const sliderRef = useRef(null);
  const slideItemRef = useRef([]);
  const [sliderProps, setSliderProps] = useState({
    scrollLeft: 0,
    scrollWidth: 0,
    clientWidth: 0,
    itemWidth: 0,
    itemsPerView: 0,
    totalSlides: 0,
    currentSlide: 0,
  });
  const rating = 4.5;
  const trustPilotStars = Array(5)
    .fill(0)
    .map((_, i) => {
      const isHalf = rating - i >= 0.5;
      const isFull = rating - i >= 1;
      const className = isFull ? 'full' : isHalf ? 'half' : '';
      return (
        <div key={i} className={`star ${className}`}>
          <svg
            width="53"
            height="53"
            viewBox="0 0 53 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.5 40.2854L37.9063 37.2311L42.6719 52.75L26.5 40.2854ZM52.75 20.2264H32.6719L26.5 0.25L20.3281 20.2264H0.25L16.5 32.6085L10.3281 52.5849L26.5781 40.2028L36.5781 32.6085L52.75 20.2264Z"
              fill="white"
            />
          </svg>
        </div>
      );
    });
  const reviews = [
    {
      id: 1,
      name: 'ALTV Group',
      comment: [
        "Knowing Casava offers affordable health care always give me joy. It has been my health go to more than a year now. Don't joke with your health embrace a plan today. Keep it up, Casava.",
      ],
      rating: 5,
    },
    {
      id: 2,
      name: 'Usoro Gladys',
      comment: [
        'I initially was skeptical about registering. I had to give in when the mails and adverts kept popping up. I said, let me see what this has to offer in reality.',
        "After much attempts to meet with the Doctor in my chosen clinic, I was amazed when I finally met her... the manner she handled the situation and attended to me won me over. I was even administered drugs in my first contact... Amazing, isn't it?!",
        'I hope the program continues like this so that we can give it the popularity it deserves.',
        'However, it will be much more interesting if there could be family packages. This will give room to infants and adults alike buying into the policy. ',
      ],
      rating: 5,
    },
    {
      id: 3,
      name: 'Usoro Gladys',
      comment: [
        "I have a great experience at Mark of Glory specialist hospital MCC Owerri last weekend as I was treated of malaria with the help of Casava HMO and to my surprise, I didn't pay a dime after the treatment. Thank you Casava health insurance scheme for service to humanity.",
      ],
      rating: 5,
    },
    {
      id: 4,
      name: 'Samuel Onyeulor',
      comment: [
        "The quality of service I got from my hospital as a result of the Cassava health insurance was second to none. I didn't have to book ahead before visiting the hospital. The confirmation was prompt and swift and I was not instructed to sign a blank treatment cost sheet by the hospital i.e Mother Theresa Medical Centre, Idimu.",
        'I sincerely wish there is a family plan so.',
      ],
      rating: 5,
    },
    {
      id: 5,
      name: 'Marilyn Olungweonwi',
      comment: [
        'What stood out for me was the simplicity and clarity. You book an appointment, get to the hospital, submit your policy number and you’re attended to, easy-peasy.',
        'In addition, when there was a mixup with my very first appointment, the follow up was really prompt and impressive.',
      ],
      rating: 5,
    },
    {
      id: 6,
      name: 'Ralph Chisom Adiele',
      comment: [
        'I am so happy to be a beneficiary to Cassava Health Insurance Company. I have been receiving health care, free of charge, by just paying 1,100 Naira only, to be fully treated. I always go to Obioma Hospital School Road Umuahia, to receive my treatments free of charge and their services are 100% impressive. So, I encourage others to join in this wonderful journey. It is a great experience.',
        'I always enjoy your online tutorials on different topics in health, business and insurance, you are doing perfectly well. God bless you so much for making me a participant in the webiner cassava lectures. Please, keep it up! Bravo! I am so happy.',
      ],
      rating: 5,
    },
    {
      id: 7,
      name: 'Vera',
      comment: [
        "I joined Casava in November 2022 mainly because I needed access to a gynae and ever since I joined, it's been great. Response to fixing appointment is very prompt and interactions with their clients is topnotch. I will definitely recommend Casava Insurance.",
      ],
      rating: 5,
    },
    {
      id: 8,
      name: 'Adebayo Lukman',
      comment: [
        'My experience has been splendid since I begin to harness this policy. the response time from the casava staff was good while the hospital also gave me a first hand treatment ranging from the diagnosis by the doctor to the laboratory attention. I really like recomend this health policy for betterment of the generality.',
      ],
      rating: 5,
    },
  ].map((review) => {
    return {
      ...review,
      stars: Array(5)
        .fill(0)
        .map((_, i) => {
          const isFull = review.rating - i >= 1;
          return (
            <div key={i} className="star">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.78487 0.85999C8.28899 0.624795 7.71372 0.624795 7.21784 0.859989C6.87455 1.02281 6.63103 1.33101 6.41526 1.67934C6.19831 2.02957 5.96029 2.50562 5.66389 3.09844L5.66389 3.09846L5.65228 3.12168L5.41339 3.59947C5.21013 4.00597 5.15103 4.1125 5.07683 4.19017C5.00029 4.27028 4.90851 4.33428 4.80688 4.37841C4.70835 4.42118 4.58795 4.43982 4.13626 4.49001L3.91939 4.51411L3.89337 4.517H3.89336C3.18129 4.59611 2.61247 4.65931 2.18182 4.74691C1.75709 4.8333 1.36127 4.96118 1.08419 5.24388C0.687756 5.64835 0.501123 6.2137 0.578835 6.7747C0.63315 7.16678 0.875038 7.50522 1.16485 7.82751C1.45871 8.15424 1.87812 8.54375 2.40314 9.03126L2.42232 9.04908L2.65127 9.26165C3.04897 9.63094 3.15093 9.7354 3.20806 9.84664C3.26705 9.96154 3.29846 10.0885 3.29982 10.2177C3.30114 10.3425 3.25878 10.485 3.07665 11.0041L3.06805 11.0287L3.06803 11.0287C2.79926 11.7947 2.5864 12.4014 2.46555 12.8733C2.34815 13.3318 2.28237 13.782 2.43542 14.1718C2.6508 14.7204 3.1174 15.1316 3.68873 15.2762C4.0936 15.3787 4.52809 15.2593 4.96421 15.0873C5.41192 14.9107 5.97884 14.6272 6.69363 14.2698L6.71703 14.2581L7.27282 13.9802C7.64756 13.7928 7.74989 13.7467 7.84809 13.7283C7.94936 13.7093 8.05335 13.7093 8.15461 13.7283C8.25282 13.7467 8.35515 13.7928 8.72988 13.9802L9.28567 14.2581L9.30914 14.2698C10.0239 14.6272 10.5908 14.9107 11.0385 15.0873C11.4746 15.2593 11.9091 15.3787 12.314 15.2762C12.8853 15.1316 13.3519 14.7204 13.5673 14.1718C13.7204 13.782 13.6545 13.3318 13.5372 12.8733C13.4163 12.4014 13.2035 11.7947 12.9346 11.0287V11.0286L12.9261 11.0041C12.7439 10.485 12.7016 10.3425 12.7029 10.2177C12.7043 10.0885 12.7356 9.96154 12.7947 9.84664C12.8518 9.7354 12.9537 9.63094 13.3515 9.26165L13.5804 9.04908L13.5996 9.03119C14.1246 8.54368 14.544 8.15424 14.8378 7.82751C15.1277 7.50522 15.3696 7.16678 15.4239 6.7747C15.5016 6.2137 15.315 5.64835 14.9185 5.24388C14.6414 4.96118 14.2456 4.8333 13.8209 4.74691C13.3902 4.65931 12.8214 4.59611 12.1094 4.517L12.0833 4.51411L11.8665 4.49001C11.4147 4.43982 11.2943 4.42118 11.1959 4.37841C11.0942 4.33428 11.0024 4.27028 10.9259 4.19017C10.8517 4.1125 10.7926 4.00597 10.5893 3.59946L10.3504 3.12168L10.3388 3.09845C10.0424 2.50562 9.80443 2.02957 9.58747 1.67934C9.37171 1.33101 9.12823 1.02281 8.78487 0.85999Z"
                  fill={isFull ? '#FACA15' : '#F5F5F5'}
                />
              </svg>
            </div>
          );
        }),
    };
  });

  const updateSliderProps = () => {
    if (!sliderRef.current) return;

    const slider = sliderRef.current;
    const scrollLeft = slider.scrollLeft;
    const scrollWidth = slider.scrollWidth;
    const clientWidth = slider.clientWidth;
    const itemWidth = slideItemRef.current[0].clientWidth;
    const itemsPerView = Math.floor(clientWidth / itemWidth);
    const totalSlides = Math.ceil(scrollWidth / clientWidth);
    const currentSlide = Math.floor(scrollLeft / clientWidth);

    setSliderProps({
      scrollLeft,
      scrollWidth,
      clientWidth,
      itemWidth,
      itemsPerView,
      totalSlides,
      currentSlide,
    });
  };
  // const slideNext = () => {
  //   if (!sliderRef.current) return;
  //   const slider = sliderRef.current;
  //   const { scrollLeft, itemWidth, itemsPerView } = sliderProps;
  //   const nextScrollLeft = scrollLeft + itemsPerView * itemWidth;
  //   slider.scrollTo({
  //     left: nextScrollLeft,
  //     behavior: 'smooth',
  //   });
  // };

  // const slidePrev = () => {
  //   if (!sliderRef.current) return;
  //   const slider = sliderRef.current;
  //   const { scrollLeft, itemWidth, itemsPerView } = sliderProps;
  //   const nextScrollLeft = scrollLeft - itemsPerView * itemWidth;
  //   slider.scrollTo({
  //     left: nextScrollLeft,
  //     behavior: 'smooth',
  //   });
  // };

  const slideTo = (index) => {
    if (!sliderRef.current) return;
    const slider = sliderRef.current;
    const { clientWidth } = sliderProps;
    const nextScrollLeft = index * clientWidth;
    slider.scrollTo({
      left: nextScrollLeft,
      behavior: 'smooth',
    });
  };

  useLayoutEffect(() => {
    const slider = sliderRef.current;
    updateSliderProps();
    window.addEventListener('resize', updateSliderProps);
    slider?.addEventListener?.('scroll', updateSliderProps);
    return () => {
      window.removeEventListener('resize', updateSliderProps);
      slider?.removeEventListener?.('scroll', updateSliderProps);
    };
  }, []);

  return (
    <section className="reviews--section">
      <div className="container">
        <div className="reviews--intro">
          <h1 className="reviews--heading">
            What our <br className="hidden md:block" />
            customers say
          </h1>
          <div>
            <div className="reviews--card reviews--rating--card">
              <div className="reviews--rating--score">Excellent</div>
              <div className="stars">{trustPilotStars}</div>
              <div>
                Based on{' '}
                <a
                  href="https://www.trustpilot.com/review/casava.com"
                  target="_blank"
                  rel="noreferrer"
                  className="underline font-semibold"
                >
                  456 reviews
                </a>
              </div>
              <div className="reviews--trust-pilot-logo">
                <svg
                  width="197"
                  height="45"
                  viewBox="0 0 197 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.2501 34.316L34.5803 31.6981L38.8964 45L24.2501 34.316ZM48.0237 17.1226H29.8398L24.2501 0L18.6605 17.1226H0.476562L15.1936 27.7358L9.60391 44.8585L24.3209 34.2453L33.3775 27.7358L48.0237 17.1226Z"
                    fill="#468F50"
                  />
                  <path
                    d="M67.4914 33.5H62.7554V15.644H56.2274V11.1H74.0514V15.644H67.4914V33.5ZM74.3422 33.5V17.788H78.8542V19.74C79.5262 18.396 81.2542 17.468 82.6302 17.468C83.4622 17.468 84.2302 17.596 84.7102 17.82L84.1982 22.204C83.5902 21.948 82.8862 21.82 82.1822 21.82C80.6782 21.82 78.8542 22.972 78.8542 25.756V33.5H74.3422ZM97.3427 33.5V31.452C96.3507 32.956 94.8787 33.82 93.0867 33.82C89.0547 33.82 86.6227 31.132 86.6227 26.684V17.788H91.1347V26.108C91.1347 28.156 92.3827 29.5 94.2387 29.5C96.1267 29.5 97.3427 28.156 97.3427 26.108V17.788H101.855V33.5H97.3427ZM111.397 33.852C108.709 33.852 105.861 32.956 104.229 31.58L105.925 28.22C107.109 29.308 109.541 30.076 111.301 30.076C112.389 30.076 113.157 29.596 113.157 28.956C113.157 26.908 104.901 28.476 104.901 22.684C104.901 19.612 107.525 17.468 111.301 17.468C113.477 17.468 115.845 18.012 117.413 19.26L115.749 22.748C114.373 21.724 111.973 21.212 110.821 21.212C109.957 21.212 109.381 21.628 109.381 22.268C109.381 24.156 117.701 23.164 117.701 28.796C117.701 31.708 115.077 33.852 111.397 33.852ZM127.714 33.756C124.034 33.756 121.442 31.42 121.442 27.356V22.076H118.53V17.788H121.442V13.66H125.954V17.788H129.826V22.076H125.954V27.132C125.954 28.604 127.074 29.532 128.386 29.532C128.834 29.532 129.442 29.436 129.794 29.308L130.018 33.308C129.442 33.596 128.546 33.756 127.714 33.756ZM140.978 21.788C138.898 21.788 137.234 23.26 137.042 25.308V26.044C137.234 28.028 138.866 29.532 140.946 29.532C143.122 29.532 144.914 27.804 144.914 25.66C144.914 23.484 143.154 21.788 140.978 21.788ZM132.498 38.684L132.53 17.788H137.042V20.028C138.13 18.396 139.794 17.468 142.002 17.468C146.098 17.468 149.33 21.148 149.33 25.66C149.33 30.172 146.066 33.82 141.97 33.82C139.794 33.82 138.098 32.924 137.01 31.292V38.684H132.498ZM151.811 17.788H156.323V33.5H151.811V17.788ZM151.299 12.892C151.299 11.42 152.547 10.172 154.051 10.172C155.555 10.172 156.803 11.42 156.803 12.892C156.803 14.396 155.555 15.644 154.051 15.644C152.547 15.644 151.299 14.396 151.299 12.892ZM164.292 11.1V33.5H159.78V11.1H164.292ZM174.83 17.468C179.438 17.468 182.99 20.988 182.99 25.66C182.99 30.332 179.438 33.82 174.83 33.82C170.19 33.82 166.67 30.332 166.67 25.66C166.67 20.988 170.19 17.468 174.83 17.468ZM171.054 25.66C171.054 27.836 172.686 29.5 174.83 29.5C176.942 29.5 178.606 27.836 178.606 25.66C178.606 23.452 176.942 21.788 174.83 21.788C172.686 21.788 171.054 23.452 171.054 25.66ZM193.058 33.756C189.378 33.756 186.786 31.42 186.786 27.356V22.076H183.874V17.788H186.786V13.66H191.298V17.788H195.17V22.076H191.298V27.132C191.298 28.604 192.418 29.532 193.73 29.532C194.178 29.532 194.786 29.436 195.138 29.308L195.362 33.308C194.786 33.596 193.89 33.756 193.058 33.756Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="reviews--slider--wrapper">
          <div className="reviews--slider--track" ref={sliderRef}>
            <div className="reviews--slider">
              {reviews.map((review, reviewIndex) => (
                <Review
                  key={reviewIndex}
                  ref={(el) => (slideItemRef.current[reviewIndex] = el)}
                  {...review}
                />
              ))}
            </div>
          </div>
          <div className="reviews--slider--dots">
            {Array.from({ length: sliderProps.totalSlides - 1 }).map(
              (_, index) => {
                return (
                  <div
                    key={index}
                    className={`dot ${
                      index === sliderProps.currentSlide ? 'active' : ''
                    }`}
                    aria-selected={index === sliderProps.currentSlide}
                    onClick={() => slideTo(index)}
                  />
                );
              }
            )}
            {/* <div className="dot" aria-selected={} /> */}
          </div>
        </div>

        <div className="text-center">
          <a
            href="https://www.trustpilot.com/review/casava.com"
            target="_blank"
            rel="noreferrer"
            className="button button--black"
          >
            <span>Check out our full review</span>
          </a>
        </div>
      </div>
    </section>
  );
}

const Review = forwardRef((props, ref) => {
  const maxCommentLength = 220;
  const [canShowFull, setCanShowFull] = useState(false);
  const isTooLong = props.comment.join(' ').length > maxCommentLength;
  const comment = useMemo(() => {
    const comment = props.comment.join(' ');
    return !canShowFull && isTooLong
      ? comment.slice(0, maxCommentLength) + '...'
      : comment;
  }, [props.comment, canShowFull, isTooLong]);

  return (
    <div ref={ref} className="reviews--card reviews--comment--card">
      <p className="comment">{comment}</p>
      <div className="flex">
        <div className="w-full">
          {isTooLong && (
            <span
              className="reviews--show--more"
              onClick={() => setCanShowFull(!canShowFull)}
            >
              {canShowFull ? 'show less' : 'show more'}
            </span>
          )}
        </div>
        <div className="w-full text-right">
          <div className="comment--author">{props.name}</div>
          <div className="stars">{props.stars}</div>
        </div>
      </div>
    </div>
  );
});
